import { Component, Input } from "@angular/core";

/**
 * Presentational fragment for the shared "imaging center map + address" row that
 * appears identically inside several patient-notification email cards.
 *
 * Uses an attribute selector on a <tr> so the host element IS the table row the
 * original markup used (no extra DOM node is introduced and the rendered output
 * stays visually identical). Only the location-pin horizontal offset and its alt
 * text vary between cards, so those are exposed as inputs.
 */
@Component({
  selector: "tr[appNotificationLocation]",
  templateUrl: "./notification-location.component.html",
})
export class NotificationLocationComponent {
  // Horizontal offset (CSS `left` value) for the absolutely-positioned location pin.
  @Input() locationLeft = "340px";
  // Alt text for the location-pin image.
  @Input() alt = "group-img";
}
